import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-panel perks-container perks-area box-shadow-transition"
}
const _hoisted_2 = { class: "panel-bg" }
const _hoisted_3 = {
  key: 1,
  class: "panel-title"
}
const _hoisted_4 = {
  key: 0,
  class: "base-panel perks-container perks-area box-shadow-transition"
}
const _hoisted_5 = { class: "panel-bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "perks-transition",
      mode: "out-in",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.state.ui.showPerks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.state.build.info.currentPerk.available)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["panel-title blink", _ctx.getPerkWarningClass()])
                    }, " NEW PERK! ", 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, " PERKS ")),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.state.build.Perks), (perk) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "perk-wrapper",
                    key: perk
                  }, [
                    _createVNode(_component_GenericButton, {
                      text: _ctx.getPerkButtonName('Perks', perk),
                      "class-name": _ctx.getButtonClass('Perks', perk),
                      class: "item-hover",
                      onMouseover: ($event: any) => (_ctx.showInfo('Perks', perk)),
                      onClick: ($event: any) => (_ctx.tagPerk('Perks', perk))
                    }, null, 8, ["text", "class-name", "onMouseover", "onClick"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fake-support-perks-transition",
      mode: "out-in",
      appear: ""
    }, {
      default: _withCtx(() => [
        (!_ctx.state.ui.showPerks && _ctx.state.ui.showSupportPerks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "panel-title" }, " SUPPORT PERKS ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.state.build.SupportPerks), (perk) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "perk-wrapper",
                    key: perk
                  }, [
                    _createVNode(_component_GenericButton, {
                      text: _ctx.getPerkButtonName('SupportPerks', perk),
                      "class-name": _ctx.getButtonClass('SupportPerks', perk),
                      class: "item-hover",
                      onMouseover: ($event: any) => (_ctx.showInfo('SupportPerks', perk)),
                      onClick: ($event: any) => (_ctx.tagPerk('SupportPerks', perk))
                    }, null, 8, ["text", "class-name", "onMouseover", "onClick"])
                  ]))
                }), 128)),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "panel-title" }, " MYSTERY BOOSTS ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.state.build.MysteryBoosts), (boost) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "perk-wrapper",
                    key: boost
                  }, [
                    _createVNode(_component_GenericButton, {
                      text: _ctx.getPerkButtonName('MysteryBoosts', boost),
                      "class-name": _ctx.getButtonClass('MysteryBoosts', boost),
                      class: "item-hover",
                      onMouseover: ($event: any) => (_ctx.showInfo('MysteryBoosts', boost)),
                      onClick: ($event: any) => (_ctx.tagPerk('MysteryBoosts', boost))
                    }, null, 8, ["text", "class-name", "onMouseover", "onClick"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}